// Keep Ghost Portal and Search centered without forcing narrow screens to overflow.
function injectPortalCSS() {
	const portalRoot = document.querySelector("#sodo-search-root");
	if (!portalRoot) return;

	const iframe = portalRoot.querySelector("iframe");
	if (!iframe) return;

	const injectStyles = () => {
		let iframeDocument;
		try {
			iframeDocument = iframe.contentDocument || iframe.contentWindow?.document;
		} catch {
			return;
		}
		if (!iframeDocument || iframeDocument.querySelector("#custom-portal-css"))
			return;

		const style = iframeDocument.createElement("style");
		style.id = "custom-portal-css";
		style.textContent = `
            body {
                display: flex !important;
                align-items: center !important;
                justify-content: center !important;
                min-height: 100vh !important;
                margin: 0 !important;
            }

            .ghost-display {
                display: flex !important;
                position: fixed !important;
                inset: 0 !important;
                align-items: center !important;
                justify-content: center !important;
                width: 100% !important;
                height: 100% !important;
                padding-inline: max(16px, env(safe-area-inset-left)) max(16px, env(safe-area-inset-right)) !important;
                padding-block: max(16px, env(safe-area-inset-top)) max(16px, env(safe-area-inset-bottom)) !important;
                box-sizing: border-box !important;
            }

            .animate-popup {
                position: relative !important;
                width: min(100%, 560px) !important;
                margin: 0 auto !important;
            }

            input[placeholder*="Search"] {
                width: 100% !important;
                min-width: 0 !important;
                box-sizing: border-box !important;
            }

            .animate-fadein {
                background: rgba(0, 0, 0, 0.5) !important;
            }
        `;

		iframeDocument.head.append(style);

		const searchInput = iframeDocument.querySelector(
			'input[placeholder*="Search"]',
		);
		if (searchInput)
			searchInput.placeholder = "Search articles, topics, and authors";
	};

	injectStyles();
	window.setTimeout(injectStyles, 100);
	window.setTimeout(injectStyles, 500);
}

const observer = new MutationObserver((mutations) => {
	const portalAdded = mutations.some((mutation) =>
		Array.from(mutation.addedNodes).some(
			(node) =>
				node instanceof Element &&
				(node.id === "sodo-search-root" || node.id === "sodo-root"),
		),
	);
	if (portalAdded) injectPortalCSS();
});

observer.observe(document.body, { childList: true, subtree: true });

document.addEventListener("click", (event) => {
	if (!event.target.closest("[data-ghost-search]")) return;
	window.setTimeout(injectPortalCSS, 50);
	window.setTimeout(injectPortalCSS, 200);
});

document.addEventListener("DOMContentLoaded", injectPortalCSS);

export default injectPortalCSS;
